import {Params} from '@angular/router';
import {HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';

// import {ApiService} from 'shared/services';
// import {PropsMapping} from '@shared/interfaces';
import {ListState} from 'shared/interfaces';
// import {ListState} from '../interfaces/list-state.interface';
import {Model} from './model';

// const propsMapping: PropsMapping = {
const propsMapping: Params = {
  id: 'locationId',
  name: 'name',
  description: 'description',
  status: 'status',
};

export class LocationModel extends Model {
  name!: string;
  status!: string;

  static getInstance(data: Params): LocationModel {
    const model = new LocationModel();
    for (const prop in propsMapping) {
      if (
        data[propsMapping[prop]] === undefined ||
        data[propsMapping[prop]] === null
      ) {
        continue;
      }

      (model as Params)[prop] = data[propsMapping[prop]];
    }
    return model;
  }

  // @TODO: descomentar
  // static search(
  //   apiService: ApiService,
  //   urlParams?: HttpParams
  // ): Observable<ListState<LocationModel>> {
  //   return apiService
  //     .get('locations', urlParams)
  //     .pipe(
  //       map((data: Params): ListState<LocationModel> => {
  //         const list: LocationModel[] = data['data'].map((item: Params): LocationModel =>
  //           LocationModel.getInstance(item)
  //         );
  //
  //         // const paginator: Paginator = {
  //         //   total: data.total,
  //         //   perPage: data.perPage,
  //         //   currentPage: data.currentPage,
  //         //   lastPage: data.lastPage,
  //         //   // from: data.from,
  //         //   // to: data.to
  //         // };
  //
  //         // return {list, paginator};
  //         return {list};
  //       })
  //     );
  // }
}
